import React, { useEffect, useState } from "react";
import axios from "axios";
import PosCashierNavbar from "../../Components/PosCashierNavbar";
import Loading from "../../Components/Loading";
import { BiSolidEditAlt } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { setDivision } from "../../Redux/Action/division";
import TakeOrder from "../ORDERTAKER/TakeOrder";
import CashPOSPopUp from "../ORDERTAKER/CashPOS";

const PosCashierUnpaidBills = ({ hideNavBar }) => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [search, setSearch] = useState("");
  const [isloading, setisloading] = useState(false);
  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const localStartOfMonth = new Date(
    startOfMonth.getTime() - startOfMonth.getTimezoneOffset() * 60000,
  );

  const [startdate, setStartdate] = useState(localStartOfMonth.toISOString());
  const [enddate, setEnddate] = useState(currentDate.toISOString());

  const [orderHeaders, setOrderHeaders] = useState([]);
  const [totalAmount, setTotalAmount] = useState("");
  const divisionState = useSelector((state) => state.changeDivision);
  const userState = useSelector((state) => state.changeTheState.user);
  const loggedInEmail = userState?.emailId;
  const loggedInUser = userState?.emailId?.split("@")[0]?.toUpperCase();
  const [status, setStatus] = useState("");
  const dispatch = useDispatch();
  const [showTakeOrder, setShowTakeOrder] = useState(false);
  const [showCashPos, setShowCashPos] = useState(false);
  const [orderNo, setOrderNo] = useState("");

  const [tablesList, setTablesList] = useState([]);
  const [selTable, setSelTable] = useState("");
  const [waiterList, setWaiterList] = useState([]);
  const [selWaiter, setSelWaiter] = useState("");

  // Total calculations
  // Filters
  const filtOrders = orderHeaders.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    // const itemDate = new Date(item.DATETIME);

    const itemDate = item.DATETIME
      ? new Date(item.DATETIME.replace("Z", ""))
      : null;

    const start = startdate ? new Date(startdate) : null;
    const end = enddate ? new Date(enddate) : null;

    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(23, 59, 59, 999);

    if (searchData.length === 0 && !startdate && !enddate && !selTable && !selWaiter) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["BILLNO", "TABLENO", "DIVISION", "CURRENCY", "WAITER","RECEIPTAMOUNT","AMOUNT"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    const dateMatch =
          (!start || itemDate >= start) && (!end || itemDate <= end);
      
          const tableMatch =
      !selTable ||
      selTable.toLowerCase() === item?.TABLENO?.toLowerCase();

          const waiterMatch =
      !selWaiter ||
      selWaiter.toLowerCase() === item?.WAITER?.toLowerCase();

    return textMatch && dateMatch && tableMatch && waiterMatch;
  });

  useEffect(() => {
    let totalAmounts = 0;

    filtOrders.forEach((item) => {
      totalAmounts += parseFloat(item.AMOUNT);
    });

    setTotalAmount(totalAmounts);
  }, [filtOrders]);

  useEffect(() => {
    getOrderHeaders();
  }, []);

  function getOrderHeaders() {
    setisloading(true);

    axios
      .get(`${BASEURL}/getdivisionRights?OM_USER_ACCOUNT=${loggedInEmail}`)
      .then((response) => {
        dispatch(setDivision(response?.data[0]?.OM_USER_DIVISION || ""));
      })
      .catch((err) => {
        console.log(
          "Error while fetching Division Rights : /getdivisionRights",
          err,
        );
        setisloading(false);
      });
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1680`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        const sortedData = res.data.sort((a, b) => b.BILLNO - a.BILLNO);
        setOrderHeaders(sortedData);
        const uniqueWaiters = [
          ...new Map(res?.data?.map((item) => [item.WAITER, item])).values(),
        ];
        setWaiterList(uniqueWaiters);

        const uniqueTable = [
          ...new Map(
            res?.data?.map((item) => [item.TABLENO, item]),
          ).values(),
        ];
        setTablesList(uniqueTable);
        setisloading(false);
      })
      .catch((err) => {
        console.log("Error while fetching /getOrderHeaders", err);
        setisloading(false);
      });
  }

  if (isloading) {
    return <Loading />;
  }

  return (
    <div className="bg-gray-50 min-h-[100vh]">
      {!hideNavBar &&  divisionState && <PosCashierNavbar />}
      <section className="lg:flex flex-col mt-2 gap-5 mx-5">
        <div className="lg:flex items-center gap-3">
          <p>Search:</p>
          <input
            className="w-[300px] h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />

          <p className="text-red-600 ml-1 mr-1">Table No:</p>
          <Select
            className="w-64"
            onChange={(e) => {
              setSelTable(e.value);
            }}
            value={
              selTable
                ? { label: selTable, value: selTable }
                : { label: "", value: "" }
            }
            options={[
              { value: "", label: "All" },
              ...tablesList.map((item) => ({
                label: item.TABLENO,
                value: item.TABLENO,
              })),
            ]}
                  />
                  
                     <p className="text-red-600 ml-1 mr-1">Waiter :</p>
          <Select
            className="w-64"
            onChange={(e) => {
              setSelWaiter(e.value);
            }}
            value={
              selWaiter
                ? { label: selWaiter, value: selWaiter }
                : { label: "", value: "" }
            }
            options={[
              { value: "", label: "All" },
              ...waiterList.map((item) => ({
                label: item.WAITER,
                value: item.WAITER,
              })),
            ]}
          />
              </div>
              
              <div className="lg:flex items-center gap-3">
                   <p className="text-red-600 ml-2">Start Date:</p>
          <input
            type="date"
            className="w-36 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            onChange={(e) => {
              setStartdate(e.target.value);
            }}
            value={startdate.split("T")[0]}
          ></input>
          <p className="text-red-600 ml-2">End Date:</p>
          <input
            type="date"
            className="w-36 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            onChange={(e) => {
              setEnddate(e.target.value);
            }}
            value={enddate.split("T")[0]}
          ></input>
              </div>
      </section>

      <div className="overflow-y-auto h-[300px] px-4">
        {filtOrders.length > 0 ? (
          <>
            <aside className="table__pos__app text-sm ">
              <table class="custom-table">
                <thead class="header-cell">
                  <tr>
                    <td className="text-left">S no</td>
                    <td className="text-left">DIVISION</td>
                    <td className="pl-2">ORDER NO</td>
                    <td className="text-left">TABLE NO</td>
                    <td className="text-left">WAITER</td>
                    <td className="text-left">ORDER TIME</td>
                    <td className="text-right">AMOUNT</td>
                    <td className="text-right">RECEIPT AMOUNT</td>
                    <td className="text-right">PENDING</td>
                    <td className="text-right">CURRENCY</td>
                  </tr>
                </thead>
                <tbody>
                  {filtOrders.map((row, index) => (
                    <tr
                      key={row?.BILLNO}
                      className={
                        index < orderHeaders.length
                          ? "border-b cursor-pointer text-sm table-row"
                          : ""
                      }
                      onClick={() => {
                        setOrderNo(row.BILLNO);
                        setShowTakeOrder(true);
                      }}
                    >
                      <td className="text-right">{index + 1}</td>
                      <td className="text-left">{row.DIVISION || ""}</td>
                      <td className="text-right pr-12">
                        {row.BILLNO ? row.BILLNO : ""}
                      </td>
                      <td className="text-left">
                        {row?.TABLENO ? row?.TABLENO : ""}
                      </td>
                      <td className="text-left">
                        {row?.WAITER ? row?.WAITER : ""}
                      </td>
                      <td className="text-left">
                        {row.DATETIME
                          ? moment
                              .utc(row.DATETIME)
                              ?.format("DD-MM-YYYY HH:mm:ss")
                          : ""}
                      </td>
                      <td className="text-right pr-12">
                        {row.AMOUNT
                          ? row.AMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-right pr-12">
                        {row.RECEIPTAMOUNT
                          ? row.RECEIPTAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-right pr-12">
                        {row.PENDING
                          ? row.PENDING.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-left">{row.CURRENCY || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </aside>
            <div className="flex gap-2 ml-48">
              <p className=" text-gray-700">Total Orders :</p>
              <span className="font-extrabold">
                {filtOrders.length > 0 ? filtOrders.length : "0"}
              </span>
              <p>|</p>
              <p className=" text-gray-700">Total Amount :</p>
              <span className="font-extrabold">
                {totalAmount
                  ? totalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "0.0"}
              </span>
            </div>
          </>
        ) : (
          <div className="flex justify-center mt-4">
            <h1 className="font-extrabold text-3xl">No Orders Available</h1>
          </div>
        )}
      </div>

      <div className="flex justify-center">
        <button
          className="flex items-center justify-center h-8 border border-black bg-[#002d62] text-white rounded-md px-4 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            setShowCashPos(true);
          }}
        >
          TAKE ORDER
        </button>
      </div>

      {showTakeOrder && (
        <div className="fixed top-[70px] left-1/2 -translate-x-1/2 bg-white border border-black lg:h-[calc(100vh-90px)] h-[calc(100vh-80px)] lg:w-[1300px] w-[95%] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
          <CashPOSPopUp ordernoToPass={orderNo} hideNavbar={true} />

          <button
            className="absolute top-[15px] right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowTakeOrder(false)}
          >
            Close
          </button>
        </div>
      )}

      {showCashPos && (
        <div className="fixed top-[70px] left-1/2 -translate-x-1/2 bg-white border border-black lg:h-[calc(100vh-90px)] h-[calc(100vh-80px)] lg:w-[1300px] w-[95%] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
          <CashPOSPopUp hideNavbar={true} />

          <button
            className="absolute top-[15px] right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowCashPos(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default PosCashierUnpaidBills;
